import { CSSProperties, ReactNode } from 'react';

import type { ControlProps as RSControlProps, GroupBase } from 'react-select-5';

type ControlProps<Option, IsMulti extends boolean, Group extends GroupBase<Option>> = RSControlProps<
  Option,
  IsMulti,
  Group
> & {
  label?: ReactNode;
};

export function Control<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: ControlProps<Option, IsMulti, Group>,
) {
  const { innerProps, getClassNames, getStyles, label, children } = props;
  return (
    <div
      {...innerProps}
      className={getClassNames('control', props)}
      style={getStyles('control', props) as CSSProperties}
    >
      {label}
      {children}
    </div>
  );
}
